import GenericErrorModal from 'ui/src/components/GlobalModals/GenericErrorModal/GenericErrorModal';
import { withGenericErrorModalProps } from 'viewModel/globalModals/genericErrorModal/withGenericErrorModalProps';

export default withGenericErrorModalProps(GenericErrorModal);
